import { groupBy } from 'lodash';
var TabAttachmentsComponent = /** @class */ (function () {
    function TabAttachmentsComponent(data) {
        this.data = data;
        var grouped = groupBy(this.data.maintenance.attachments, 'type');
        this.requestAttachments = grouped['request'];
        this.integrationAttachments = grouped['integration'];
    }
    return TabAttachmentsComponent;
}());
export { TabAttachmentsComponent };
